export const ConfigurationManager = {
    REACT_FEATURE_BU: "PRE",
    REACT_APP_LOCAL_SERVICE_URL: "https://ams-dev2.integritymarketing.com",
    REACT_APP_CLIENT_ID: "b1f6593c-8e6f-479e-ad41-e323794125b2",
    REACT_APP_PROD_CLIENT_ID: "b2c20358-247b-4628-b4c0-9f0e3bb2ee8f",
    REACT_APP_QA_CLIENT_ID: "9baeb1be-2e00-4020-9561-71dd719dd49a",
    REACT_APP_STAGE_CLIENT_ID: "a54dc602-bcfb-4a9c-8186-7da518573e3b",
    REACT_APP_UAT_CLIENT_ID: "a934267e-56a7-4440-9b03-3544f2605708",
    microServices: {
        releaseNotes: "https://ams-pre-dev.integritymarketing.com",
        snowflakeQuery: "https://ams-pre-dev.integritymarketing.com",
        inviteService: "https://ams-pre-dev.integritymarketing.com",
    },
};

// Lower environments are hosted on pseudo business units (ams-dev2, ams-qa2, ams-uat2, ...), but RTS data is keyed by
// the real business unit code. Used for the business unit stamped on RTS attestations; never applied in production.
export const RtsBusinessUnitAliases: { [businessUnit: string]: string } = {
    DEV2: "APL",
    QA1: "PRE",
    QA2: "APL",
    UAT2: "APL",
    UAT13: "APL",
    UAT15: "Integrity",
    DEMO: "PRE",
    NNF: "N&F",
    NASB: "NSB",
    AGI: "AGB",
};

//Auth0 key configuration
export const Auth0ConfigurationManager = {
    auth0ApiKeys: [
        {
            env: ["dev", "localhost", "feature"],
            domain: "report-auth-dev.integrity.com",
            clientid: "wtkeXlAwBd1r1um9iJSJTPzefYKKujLV",
            audience: "https://ServiceAuth.com",
        },
        {
            env: ["qa"],
            domain: "connectpro-auth-qa.integrity.com",
            clientid: "uVm2oiMN9vqPbTNLy8swqSFc9UvScT6d",
            audience: "https://ServiceAuth.com",
        },
        {
            env: ["uat"],
            domain: "connectpro-auth-uat.integrity.com",
            clientid: "Jf30hJKXygNFkJnOZ8qxbQBqnfUJfxgs",
            audience: "https://ServiceAuth.com",
        },
        {
            env: ["stage"],
            domain: "connectpro-auth-stage.integrity.com",
            clientid: "nNz1x5K6UB0WRZYftlRZqh9YyAmeRaNI",
            audience: "https://ServiceAuth.com",
        },
        {
            env: ["demo"],
            domain: "img-connect-demo.us.auth0.com",
            clientid: "YrsJf1mvLssfy6l2qk0XI2RQysanIYGe",
            audience: "https://ServiceAuth.com",
        },
        {
            env: ["prod"],
            domain: "connectpro-auth-prod.integrity.com",
            clientid: "PJAGqG8izJKe8QgclglMDDUQaWyyqxKX",
            audience: "https://ServiceAuth.com",
        },
    ],
};

export enum Features {
    AGENTMANAGEMENT = "Agent Management",
    BOOKOFBUSINESS = "Book of Business",
    MANAGERTSENHANCEMENT = "Manage RTS Enhancement",
    UNIVERSALUPLOAD = "Universal Upload",
    ENHANCEDREPORTS = "Enhanced Reports",
    OUTREACH = "Outreach",
    READINESSREVIEW = "Readiness Review"
}

/**
 * Environment based configuration for the web app
 */
export const envConfigurationManager = {
    localhost: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: true },
            { name: Features.OUTREACH, isEnabled: true },
            
        ],
    },
    dev: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: true },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
    feature: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.OUTREACH, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: true }
        ],
    },
    qa: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: true },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
    uat: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: true },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
    stage: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: true },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: false },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
    demo: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: false },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: false },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
    prod: {
        features: [
            { name: Features.AGENTMANAGEMENT, isEnabled: false },
            { name: Features.BOOKOFBUSINESS, isEnabled: true },
            { name: Features.MANAGERTSENHANCEMENT, isEnabled: true },
            { name: Features.UNIVERSALUPLOAD, isEnabled: true },
            { name: Features.ENHANCEDREPORTS, isEnabled: true },
            { name: Features.READINESSREVIEW, isEnabled: false },
            { name: Features.OUTREACH, isEnabled: true },
        ],
    },
};

export const classicBUScreenConfiguration = {
    DEV: "DEV3, PRE, DIV, AEG",
    QA: "QA3, PRE, DIV, AEG",
    UAT: "PRE, NEV, DIV, AEG, UAT5",
    STAGE:
        "PRE, PGM, DIV, AEG, SAI, WMA, CRS, HSI, SIM, CIG, TBR, NASB, CRS, BER, CCI",
    PROD: "PRE, NEV, DIV, AEG, SAI, WMA, CRS, HSI, SIM, CIG, TBR, NASB, CRS, BER, CCI, DEMO",
};


export const notAllowedBUforUU = {
    DEV: "DEV3, PRE, DIV, AEG",
    QA: "AIP, AIM, FFL, IFC, PAC",
    UAT: "AIP, AIM, FFL, IFC, PAC, UAT3, UAT4, UAT5, UAT11, UAT12, UAT13, UAT15, UAT16, UAT19, UAT21, UAT23",
    STAGE: "AIP, AIM, FFL, IFC, PAC",
    PROD: "AIP, AIM, FFL, IFC",
};

export const contractStatus = {
    DEV: "DEV9",
    QA: "QA8",
    UAT: "UAT17, UAT24",
    PROD: "PAL, NNF",
};

export const payoutLevelRankEnabled = {
    DEV: "DEV9,DEV2,DEV7,PRE,APL,WAP",
    QA: "QA9,QA2,QA7,PRE,APL,WAP",
    UAT: "PRE,APL,WAP",
    STAGE: "PRE,APL,WAP",
    PROD: "PRE,DEMO,APL,WAP",
};

// Contracting app (iframe) base URL: localhost and prod are fixed, every other
// env (dev, qa, uat, stage, demo, feature, IC000xx) follows the same template.
// env is Utils.getAppHostKey(), or "localhost" (getAppHostKey folds localhost
// into "dev").
export const ContractingAppConfigurationManager = {
    urlTemplate: "https://ics-contracts-{env}.integritymarketinggroup.com",
    urlOverrides: {
        localhost: "http://localhost:3002",
        prod: "https://ics-contracts.integrity.com",
    } as { [env: string]: string },
};

export const getContractingAppUrl = (env: string): string => {
    const { urlTemplate, urlOverrides } = ContractingAppConfigurationManager;
    return urlOverrides[env] || urlTemplate.replace("{env}", env);
};

export const CarrierManagementAppConfigurationManager = {
    urlTemplate: "https://ics-carriermanagement-{env}.integritymarketinggroup.com",
    urlOverrides: {
        localhost: "http://localhost:3001",
    } as { [env: string]: string },
};

export const getCarrierManagementAppUrl = (env: string): string => {
    const { urlTemplate, urlOverrides } = CarrierManagementAppConfigurationManager;
    return urlOverrides[env] || urlTemplate.replace("{env}", env);
};
